module.exports = __webpack_public_path__ + "static/media/classic-find-cors.21d4fb18.gif";